// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-wizard-control',
    // #endregion
    // #region Data
    data: () => ({
        _pages: [],
        _activePage: ''
    }),
    // #endregion
    // #region Core
    methods: {
        isActivePage(name) {
            if (!name) {
                return false;
            }
            if (!this._activePage) {
                return false;
            }
            return this._activePage === name;
        },
        addPage(page) {
            //Append
            this._pages.push(page);
            //Active
            if (this._pages.length === 1 && !this._activePage) {
                this._activePage = page.name;
            }
        },
        removePage(page) {
            //Index
            let tIndex = this._pages.findIndex(e => e.name === page.name);
            if (tIndex >= 0) {
                this._pages.splice(tIndex, 1);
            }
            if (this._activePage === page.name && this._pages.length > 0) {
                this._activePage = this._pages[0].name;
            }
            else if (this._activePage === page.name) {
                this._activePage = '';
            }
        }
    },
    // #endregion
});
// #endregion
